import { createContext } from 'react';
import useAuth from '../../hooks/useAuth.js/index.js';

const AuthContext = createContext();

const dummySocket = {
  on: () => dummySocket,
  off: () => dummySocket,
  emit: () => dummySocket,
  isConnected: () => false,
  connected: false,
  disconnect: () => dummySocket,
  connect: () => dummySocket,
  removeAllListeners: () => dummySocket,
};

const AuthProvider = ({ children }) => {
  const {
    loading,
    user,
    isAuth,
    handleLogin,
    handleLogout,
    socket: realSocket,
  } = useAuth();

  const socket =
    realSocket && typeof realSocket.on === 'function'
      ? realSocket
      : dummySocket;

  return (
    <AuthContext.Provider
      value={{ loading, user, isAuth, handleLogin, handleLogout, socket }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
